module.exports = __webpack_public_path__ + "img/825.885fc8cb.png";